"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const styles_1 = require("./styles");
const MenuItem_1 = require("../MenuItem");
class Navbar extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.state = {
            isOpened: false,
        };
        // logout = async () => {
        //   await Session.clear();
        //   this.props.history.push("login");
        //   if (this.props.onLogout) this.props.onLogout();
        // };
        this.toggleMenu = async () => {
            console.log("toggle");
            await this.setState({ isOpened: !this.state.isOpened });
        };
    }
    render() {
        const classesNavbar = classnames_1.default([
            "navbar-default",
            { "nav-open": this.state.isOpened },
        ]);
        const classesMenuButton = classnames_1.default([
            "btn",
            "btn-primary",
            "btn-menu-close",
            { "nav-open": this.state.isOpened },
        ]);
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(styles_1.NavbarContainer, { className: classesNavbar },
                react_1.default.createElement(styles_1.NavbarHeader, null,
                    react_1.default.createElement(styles_1.NavbarHeaderLogo, { src: this.props.logo, alt: "logo" })),
                react_1.default.createElement(styles_1.NavbarMenu, null, this.props.routes.map((route, index) => {
                    if (route.showInMenu) {
                        return (react_1.default.createElement(MenuItem_1.MenuItem, { key: index, route: route, iconPosition: 'left' }));
                    }
                    else
                        return null;
                })),
                react_1.default.createElement(styles_1.Version, null,
                    "Vers\u00E3o ",
                    this.props.version)),
            react_1.default.createElement(styles_1.NavbarCloseButton, { className: classesMenuButton, onClick: () => this.setState({ isOpened: false }) },
                react_1.default.createElement("i", { className: "fas fa-times fa-3x" }))));
    }
}
exports.Navbar = Navbar;
